module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17ZUwkc/tc-custom/FC-9789948258445.jpg?1685204504995?1705766048241",
      "alt": "This image is the cover for the book Phonological Error Patterns from a Clinical Perspective"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Phonological Error Patterns from a Clinical Perspective\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Speech has two aspects, knowledge (phonology) and expression (articulation). During the development of phonology, children make systematic errors, targeting certain phonological element classes, called phonological error patterns which later on are modified and suppressed. These patterns may be normal or unusual, and are classified as syllable structure, substitution and assimilation error patterns. Assessment of these error patterns by either spontaneous sample speech or single word test is a golden step for determination of age-appropriate, delayed, gross-included and unusual patterns to help in diagnosis of phonological disorders which comprise the largest group of speech sound disorders. Difference between phonology and articulation; normal speech development; overview of phonological error patterns; approach to diagnosis of speech sound disorders are discussed in this book. This book is a guide for phoniatrician [https://www.google.com/search?safe=strict&q=phoniatrician&spell=1&sa=X&ved=0ahUKEwizhPDV0s_fAhUGWxUIHWKwDDYQBQgqKAA]s and speech-language pathologists for the better understanding of phonological error patterns and comprehensive diagnosis of speech sound disorders.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mona Rabea\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Mona Rabea is a phoniatrician with MSc of Phoniatrics (2017), M.B.B.Ch. (2008), Faculty of Medicine, Mansoura University, Egypt. She is interested in academic writing on phoniatrics.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0